import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import { theme } from "./Assets/theme";
import { jsx as _jsx } from "react/jsx-runtime";
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(/*#__PURE__*/ // <React.StrictMode>
_jsx(Provider, { store: store, children: /*#__PURE__*/ _jsx(ConfigProvider, { theme: theme, children: /*#__PURE__*/ _jsx(SnackbarProvider, { maxSnack: 5 // preventDuplicate
            ,
            autoHideDuration: 3000, anchorOrigin: { vertical: "bottom", horizontal: "right" }, children: /*#__PURE__*/ _jsx(BrowserRouter, { children: /*#__PURE__*/ _jsx(App, {}) }) }) }) }) // </React.StrictMode>
);
